import type { WorkExperienceItem } from "components/Screens/Marketplace/Customer/types";

import verifiedIcon from "components/Screens/Marketplace/Customer/assets/common/verified.svg";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Tooltip from "@mui/material/Tooltip";

import { Withheld } from "components/Screens/Marketplace/Customer/common/Withheld";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

interface WorkExperienceSectionProps {
  experience: WorkExperienceItem[];
}

function WorkExperienceSection({ experience }: WorkExperienceSectionProps) {
  if (!experience || experience.length === 0) {
    return null;
  }

  return (
    <div id="work" className="profile-content__section">
      <div className="profile-content__title-row mb-075">
        <div className="profile-content__title">Work experience</div>
      </div>
      <div className="work-experience-timeline">
        {experience.map((item, index) => (
          <div className={`work-experience-item ${index === experience.length - 1 ? "last" : ""}`}>
            <div className="work-experience-item__date">{item.dateRange}</div>
            <div className="work-experience-item__content">
              <div className="work-experience-item__header">
                <div className="work-experience-item__title-row">
                  <span className="work-experience-item__job-title">{item.jobTitle}</span>
                  <span className="work-experience-item__at"> at </span>
                  {item.companyWithheld ? (
                    <Withheld className="work-experience-item__company" tip="employer" />
                  ) : (
                    <span className={`work-experience-item__company ${item.isEdgeCustomer ? "edge-customer" : ""}`}>
                      {item.companyName}
                    </span>
                  )}
                  {item.isEdgeCustomer && (
                    <Tooltip
                      title="This experience was gained through Edge—working with one of our customers."
                      slotProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#333333",
                            color: "white",
                            fontSize: "12px",
                            maxWidth: "200px",
                          },
                        },
                      }}
                    >
                      <div className="work-experience-item__verified-icon" style={{ cursor: "normal" }}>
                        <img src={verifiedIcon} alt="Edge Customer" />
                      </div>
                    </Tooltip>
                  )}
                </div>
              </div>
              <div className="work-experience-item__date--mobile">{item.dateRange}</div>
              <div className="work-experience-item__responsibilities">
                <ul>
                  {item.responsibilities.map((responsibility) => (
                    <li key={responsibility}>{responsibility}</li>
                  ))}
                </ul>
              </div>
              {item.customerReview && (
                <div className="work-experience-item__review">
                  <div className="customer-review">
                    <div className="customer-review__quote-icon">
                      <FormatQuoteIcon style={{ color: "var(--color-text-body-primary)" }} />
                    </div>
                    <div className="customer-review__content">
                      <div className="customer-review__text">{item.customerReview.text}</div>
                      <div className="customer-review__author">
                        <div className="customer-review__name">{item.customerReview.reviewerName}</div>
                        <div className="customer-review__title">{item.customerReview.reviewerTitle}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WorkExperienceSection;
